export const FormatBoldIcon = ({ width = '20', height = '20', stroke = 'currentColor' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
    <path
      d="M5 9.99998H12.5C13.3841 9.99998 14.2319 10.3512 14.857 10.9763C15.4821 11.6014 15.8333 12.4493
       15.8333 13.3333C15.8333 14.2174 15.4821 15.0652 14.857 15.6903C14.2319 16.3155 13.3841 16.6666
       12.5 16.6666H5.83333C5.61232 16.6666 5.40036 16.5788 5.24408 16.4226C5.0878 16.2663 5 16.0543
       5 15.8333V4.16665C5 3.94563 5.0878 3.73367 5.24408 3.57739C5.40036 3.42111 5.61232 3.33331
       5.83333 3.33331H11.6667C12.5507 3.33331 13.3986 3.6845 14.0237 4.30962C14.6488 4.93474 15
       5.78259 15 6.66665C15 7.5507 14.6488 8.39855 14.0237 9.02367C13.3986 9.64879 12.5507 9.99998
       11.6667 9.99998"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
